// extracted by mini-css-extract-plugin
export default {"info-container":"xx3xDUoi2Fag6mc9NlxJ","row":"wkAytEmuErVhehJIi97M","label":"lGcYPwTsH30OxAXoC2D6","value":"XnYsmox1ZZiV67OxbwFS","table":"GKkP7w95XJF_cgK3n8dh"};